import React from 'react';
import Login from '../../Components/Login';
import SiteNavbar from '../../Components/SiteNavbar/SiteNavbar';

function LoginPage (){
    const backgoundStyle={
        backgroundImage: 'url(/img/HEB.jpg)',
        backgroundPosition: 'center',
        width: '100vw',
        height: '100vh',
        backgroundSize: 'cover'
        // opacity: '0.5'
    };

    return(
        <div style = {backgoundStyle}>
            <SiteNavbar /><br/>
            <Login />
        </div>
    );
};

export default LoginPage;